import React, { FC, useState, ReactNode } from 'react';
import styled from 'styled-components';

import ArchiveIcon from '@ad-scripts/presentation/components/common/icons/archive';
import { ButtonTypes } from '@ad-scripts/presentation/components/common/button';
import { StyledConfirmOrCancelModal } from './StyledConfirmOrCancelModal';
import { Tooltip } from 'src/presentation/components/agent_desktop_components';
import UnarchiveIcon from '@ad-scripts/presentation/components/common/icons/unarchive';

type ArchiveIconProps = {
  confirmationText?: string;
  description?: string | ReactNode;
  submitText?: string;
  itemId: string;
  onArchive: Function;
  isUnarchive?: boolean;
};

const Archive: FC<ArchiveIconProps> = ({
  confirmationText,
  description,
  submitText,
  itemId,
  onArchive,
  isUnarchive,
}) => {
  const [isArchiveModalVisible, setIsArchiveModalVisible] = useState(false);
  const openModal = function () {
    setIsArchiveModalVisible(true);
  };
  const handleCancel = function () {
    setIsArchiveModalVisible(false);
  };
  const handleSubmit = function () {
    onArchive();
    setIsArchiveModalVisible(false);
  };
  return (
    <>
      <Tooltip message={isUnarchive ? 'Unarchive' : 'Archive'} style={{ left: '5px' }} margin={13}>
        <ArchiveButton data-aid={`archiveButton-${itemId}`} onClick={openModal}>
          {isUnarchive ? <UnarchiveIcon /> : <ArchiveIcon />}
        </ArchiveButton>
      </Tooltip>
      {isArchiveModalVisible ? (
        <StyledConfirmOrCancelModal
          onCancel={handleCancel}
          onSubmit={handleSubmit}
          submitButtonType={ButtonTypes.PRIMARY}
          submitText={submitText}
          text={description}
          title={confirmationText}
        />
      ) : null}
    </>
  );
};

const ArchiveButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  visibility: hidden;
  color: ${p => p.theme.colors.gray500};
  cursor: pointer;
  & svg {
    height: 16px;
  }

  &:hover {
    color: ${p => p.theme.colors.green400};
  }
`;

export { Archive };
